'use client';

import { memo } from 'react';
import {
    type Control,
    Controller,
    type FieldValues,
    type Path,
} from 'react-hook-form';
import { OtpInput } from './otp-input';

interface ControlledOtpInputProps<T extends FieldValues = FieldValues> {
    control: Control<T>;
    name: Path<T>;
    length?: number;
}

export const ControlledOtpInput = memo(function _ControlledOtpInput<
    T extends FieldValues = FieldValues,
>({ control, name, length = 6 }: ControlledOtpInputProps<T>) {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <OtpInput
                    {...field}
                    errorMessage={fieldState.error?.message}
                    isInvalid={!!fieldState.error}
                    length={length}
                    onValueChange={field.onChange}
                    value={field.value}
                />
            )}
        />
    );
}) as <T extends FieldValues = FieldValues>(
    props: ControlledOtpInputProps<T>
) => JSX.Element;
